import './Solicitacoes.css';
import Loadable from 'react-loadable';
import Loading from '../../commons/containers/Loading';

export const MinhasSolicitacoes = Loadable({
	loader: () => import('./MinhasSolicitacoes'),
	loading: Loading
});

export const DetalhesSolicitacao = Loadable({
	loader: () => import('./DetalhesSolicitacao'),
	loading: Loading
});

export const DetalhesInteracao = Loadable({
	loader: () => import('./DetalhesInteracao'),
	loading: Loading
});
